import React, {useState} from 'react';
import {concepts, Price} from "fearless-common";
import {ColumnDef} from "@tanstack/react-table";
import { Button } from 'fearless-common-ui';
import {PlusLg} from "react-bootstrap-icons";
import {externalLinks} from "../../utils/routes";
import Pages from "../../components/layout/Pages";
import OrderableTable from "../../components/layout/OrderableTable";
import {backendEndpoints} from "../../libs/backendEndpoints";
import SearchInput from "../../components/SearchInput";
import Header from '../../components/Header';
import {getCurrencySymbol} from "../../components/billing/AmountSpan";
import useTitle from "../../components/hooks/useTitle";
import CellRender from "../../components/layout/table/CellRender";

const columns: Array<ColumnDef<Price>> = [
  {id: 'id', accessorKey: 'id', header: 'ID', enableSorting: true},
  {id: 'stripe_id', accessorKey: 'stripe_id', header: 'Stripe ID', enableSorting: false},
  {
    id: 'currency',
    accessorKey: 'currency',
    header: 'Price',
    cell: ({ row }) => (
      <div className="d-flex">
        <span className="flex-grow-1">{getCurrencySymbol(row.original.currency)}</span>
        <div>
          {(row.original.unit_amount / 100).toFixed(2)}
        </div>
        <div>&nbsp;/&nbsp;{row.original.recurring_interval}</div>
      </div>
    ),
    enableSorting: false
  },
  {id: 'created_at', accessorKey: 'created_at', header: 'Created at', cell: CellRender.DateTime, enableSorting: true},
  {id: 'updated_at', accessorKey: 'updated_at', header: 'Updated at', cell: CellRender.DateTime, enableSorting: true},
]

export default function AdminStripePrices() {
  const [query, setQuery] = useState('');

  useTitle(`Admin Stripe prices`);

  return (
    <Pages.Centred padded>
      <div className="d-flex align-items-center justify-content-between">
        <Header.Admin
          description={`The prices below are registered in and synced from Stripe to ${concepts.CompanyName}.`}
        >
          <span className="me-3">Stripe Prices</span>
          <a href={externalLinks.newPrice} target="_blank" rel="noreferrer">
            <Button>
              <PlusLg />
              add price via product
            </Button>
          </a>
        </Header.Admin>
        <div>
          <SearchInput onChange={(e) => setQuery(e.target.value)}/>
        </div>
      </div>
      <OrderableTable
        baseEndpoint={backendEndpoints.getAdminPrices}
        memoisedColumns={columns}
        buildLink={(record) => externalLinks.stripeSearch(record.stripe_id)}
        pagination
        searchQuery={query}
      />
    </Pages.Centred>
  );
}

